import React from "react";
import { Tooltip } from "antd";
import { useHistory, useLocation } from "react-router-dom";
import { HiOutlineClipboardCheck } from "react-icons/hi";
import canViewPayrollReadiness from "../../util/payrollReadinessAccess";

const PAGE_SUFFIX = "/payroll-readiness";
const TITLE = "Payroll Checklist";

const PayrollReadinessButtonInner = () => {
  const history = useHistory();
  const location = useLocation();
  const companySlug = localStorage.getItem("companyDomain");
  const isActive = location.pathname.endsWith(PAGE_SUFFIX);

  return (
    <li className="gx-settings-dropdown">
      <Tooltip title={TITLE} placement="bottom" overlayClassName="app-topbar-tooltip">
        <button
          type="button"
          className={`app-topbar__tile${isActive ? " app-topbar__tile--active" : ""}`}
          aria-label={TITLE}
          aria-current={isActive ? "page" : undefined}
          onClick={() => history.push(`/${companySlug}${PAGE_SUFFIX}`)}
        >
          <HiOutlineClipboardCheck />
        </button>
      </Tooltip>
    </li>
  );
};

/** Header tile to the Payroll Readiness stepper. Admin + roles with the resource only. */
const PayrollReadinessButton = () => (canViewPayrollReadiness() ? <PayrollReadinessButtonInner /> : null);

export default PayrollReadinessButton;
